import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UnderlineIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 4V11C6 14.314 8.686 17 12 17C15.314 17 18 14.314 18 11V4M4 21H20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

UnderlineIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UnderlineIcon);
